import { useEffect } from 'react'
import { useTermsOfUse } from 'services/terms/terms.hooks'
import { useAccessToken } from 'services/token/token.hooks'
import { useMasquaradeToken, useMasquaradeUser } from 'services/masquarade/masquarade.hooks'
import { UserProtectedRoute } from 'routes'
import TermsOfUseForm from './TermsOfUseForm'

const TermsOfUse = () => {
  const { termsOfUse, isLoadingTermsOfUse, mutateAsyncTermsOfUse, refetch, isLoading, error } =
    useTermsOfUse()
  const { clearUserData, accessToken } = useAccessToken()
  const { clearMasquaradeToken } = useMasquaradeToken()
  const { clearMasquaradeUser } = useMasquaradeUser()

  const onExit = () => {
    clearUserData()
    clearMasquaradeToken()
    clearMasquaradeUser()
  }

  const onAccept = async () => {
    await mutateAsyncTermsOfUse(termsOfUse?.id)
    refetch()
  }

  useEffect(() => {
    if (error) {
      onExit()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  if ((isLoading || error) && !!accessToken) {
    return null
  }

  return (
    <UserProtectedRoute>
      <TermsOfUseForm
        isLoading={isLoadingTermsOfUse}
        onAccept={onAccept}
        onExit={onExit}
        termsOfUse={termsOfUse}
      />
    </UserProtectedRoute>
  )
}

export default TermsOfUse
